import { createApiConstants } from '@saucelabs/sl-util-redux';

export const createTestListTypes = (namespace) => {
  const createApiNamespacedConstants = createApiConstants.bind(null, namespace);

  return {
    SET_TEST_CASE_QUERY: `${namespace}/SET_TEST_CASE_QUERY`,
    CHANGE_PAGINATION: `${namespace}/CHANGE_PAGINATION`,
    CLEANUP: `${namespace}/CLEANUP`,
    GET_TEST_CASES: createApiNamespacedConstants('GET_TEST_CASES'),
    CHANGE_PAGE: `${namespace}/CHANGE_PAGE`,
    CHANGE_SIZE: `${namespace}/CHANGE_SIZE`,
    CHANGE_SORTING: `${namespace}/CHANGE_SORTING`,
    RESET_PAGE: `${namespace}/RESET_PAGE`,
    CHANGE_TRENDS_INTERVAL: `${namespace}/CHANGE_TRENDS_INTERVAL`,
    CHANGE_SELECTED_BAR: `${namespace}/CHANGE_SELECTED_BAR`,
    GET_TEST_CASES_CSV: createApiNamespacedConstants('GET_TEST_CASES_CSV'),
    GET_TEST_CASES_TRENDS: createApiNamespacedConstants('GET_TEST_CASES_TRENDS'),
  };
};
